import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Grid, Paper, Typography, Button } from "@mui/material";
import apiService from "../../../../../ApiService";
import { API_ENDPOINTS } from "../../../../../ApiService";
import { FormTextField } from "../../../FormStyles";

const WeightEntryForm = () => {
  const { clientID } = useParams();
  const navigate = useNavigate();
  const [entries, setEntries] = useState([{ datepoids: "", poids: "" }]);
  const [error, setError] = useState("");

  // Handle changes for each entry
  const handleEntryChange = (index, field, value) => {
    const newEntries = entries.map((entry, i) => {
      if (i === index) {
        return { ...entry, [field]: value };
      }
      return entry;
    });
    setEntries(newEntries);
  };

  // Add a new empty entry row
  const addEntry = () => {
    setEntries([...entries, { datepoids: "", poids: "" }]);
  };

  // Remove an entry row (if needed)
  const removeEntry = (index) => {
    setEntries(entries.filter((_, i) => i !== index));
  };

  // Submit all entries to the backend
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      // Prepare an array of payloads from the entries
      const payload = entries.map((entry) => ({
        datepoids: entry.datepoids,
        poids: parseFloat(entry.poids),
        clientid: parseInt(clientID),
      }));

      // Send a single POST request with the entire payload array
      const response = await apiService.post(
        API_ENDPOINTS.CLIENT_ADD_POIDS_BATCH,
        payload
      );

      if (response.status === 201) {
        console.log("All weights added successfully:", response);
        navigate(`/dashboard/${clientID}`);
      } else {
        setError("Failed to add one or more weight entries. Please try again.");
      }
    } catch (error) {
      setError("Error adding weight entries: " + error.message);
      console.error("Error adding weight entries:", error);
    }
  };

  return (
    <Paper elevation={3} style={{ padding: "20px" }}>
      <form onSubmit={handleFormSubmit}>
        {entries.map((entry, index) => (
          <Grid container spacing={2} key={index} alignItems="center">
            <Grid item xs={12} sm={5}>
              <FormTextField
                name="datepoids"
                type="date"
                value={entry.datepoids}
                onChange={(e) =>
                  handleEntryChange(index, "datepoids", e.target.value)
                }
                required
              />
            </Grid>
            <Grid item xs={12} sm={5}>
              <FormTextField
                label="Poids"
                name="poids"
                type="number"
                value={entry.poids}
                onChange={(e) =>
                  handleEntryChange(index, "poids", e.target.value)
                }
                required
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              {entries.length > 1 && (
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={() => removeEntry(index)}
                >
                  Retirer
                </Button>
              )}
            </Grid>
          </Grid>
        ))}
        {error && (
          <Typography color="error" style={{ marginTop: "10px" }}>
            {error}
          </Typography>
        )}
        <Grid container spacing={2} style={{ marginTop: "20px" }}>
          <Grid item xs={6}>
            <Button variant="outlined" onClick={addEntry} fullWidth>
              Ajouter un autre poids
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button type="submit" variant="contained" color="primary" fullWidth>
              Tout enregistrer
            </Button>
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
};

export default WeightEntryForm;
